const formatPlatformRegistrations = (set = []) => {
  return set.map((n) => {
    if (typeof n.extended_properties === 'string')
      try {
        n.extended_properties = JSON.parse(n.extended_properties);
      } catch (e) {}
    return n;
  });
};

export default formatPlatformRegistrations;
